(ns core.permission.model)

(defn coerce-required-permissions
  "Given a single keyword permission or a collection, return a seq of permission keywords."
  [required-permissions]
  (let [coerced-reqd-perms (cond
                             (keyword? required-permissions) [required-permissions]
                             (coll? required-permissions) (seq required-permissions))]
    (when (empty? coerced-reqd-perms)
      (throw (ex-info "No permission specified"
                      {:required-permissions required-permissions})))
    coerced-reqd-perms))
